import { create } from 'zustand';
export const usePartnerStore = create()((set, get) => ({
    membershipCode: '',
    myMemberships: [],
    partnerList: [],
    selectedMembership: undefined,
    selectedMembershipCampaign: undefined,
    selectedPartner: undefined,
    selectedType: 'owner',
    setMembershipCode: (membershipCode) => set(() => ({ membershipCode })),
    setMyMemberships: (myMemberships) => set(() => ({ myMemberships })),
    setPartnerList: (partnerList) => set(() => ({ partnerList })),
    setSelectedMembership: (membership) => set(() => ({ selectedMembership: membership })),
    setSelectedMembershipCampaign: (membershipCampaign) => set(() => ({ selectedMembershipCampaign: membershipCampaign })),
    setSelectedPartner: (partner) => set(() => ({ selectedPartner: partner })),
    setSelectedType: (type) => set(() => ({ selectedType: type })),
    getPartner: (partnerId) => {
        const { partnerList } = get();
        return partnerList.find((partner) => partner.id === partnerId);
    },
    getMembershipsForService: (serviceShortId) => {
        const myPartnerMemberships = get().myMemberships;
        const membershipsForService = [];
        myPartnerMemberships.forEach((membership) => {
            // Filter out inactive memberships
            if (!membership.isActive || membership.usageLimitReached)
                return;
            const productCampaigns = membership.membershipCampaign.productCampaigns.filter((pc) => pc.productId === serviceShortId);
            if (productCampaigns.length >= 1) {
                let lowestPriceCampaign = productCampaigns[0];
                if (productCampaigns.length >= 2) {
                    productCampaigns.forEach((pc) => {
                        if (pc.customerPrice < lowestPriceCampaign.customerPrice) {
                            lowestPriceCampaign = pc;
                        }
                    });
                }
                membershipsForService.push({
                    membership,
                    customerPrice: lowestPriceCampaign.customerPrice,
                });
            }
        });
        // Return memberships sorted by customer price,
        // so the cheapest one is selected by default
        return membershipsForService.sort((a, b) => a.customerPrice - b.customerPrice);
    },
    // For Selecting a Product Campaign for a Service
    selectedProductCampaignForService: undefined,
    availableProductCampaignsForService: [],
    isProductCampaignValid: false,
    setSelectedProductCampaignForService: (productCampaign) => set(() => ({ selectedProductCampaignForService: productCampaign })),
    setAvailableProductCampaignsForService: (productCampaigns) => set(() => ({ availableProductCampaignsForService: productCampaigns })),
    setIsProductCampaignValid: (isValid) => set(() => ({ isProductCampaignValid: isValid })),
    // For Product Campaigns that require a country selection
    insuranceCountry: undefined,
    setInsuranceCountry: (insuranceCountry) => set(() => ({ insuranceCountry })),
    clearInsuranceCountry: () => set(() => ({ insuranceCountry: undefined })),
    hasMotimateAccess: () => {
        const memberships = get().myMemberships;
        return memberships.some(({ isActive, membershipCampaign }) => {
            if (!isActive || !membershipCampaign.custom)
                return false;
            const customData = (typeof membershipCampaign.custom === 'string'
                ? JSON.parse(membershipCampaign.custom)
                : membershipCampaign.custom);
            return Array.isArray(customData?.motimateGroups);
        });
    },
    hasMotimateUser: () => {
        const memberships = get().myMemberships;
        return memberships.some((partnerMembership) => {
            if (!partnerMembership.isActive || !partnerMembership.custom)
                return false;
            const customData = (typeof partnerMembership.custom === 'string'
                ? JSON.parse(partnerMembership.custom)
                : partnerMembership.custom);
            return typeof customData?.motimateUserId === 'number';
        });
    },
}));
